import { Helmet, HelmetProvider } from 'react-helmet-async';
import favicon from '../imagenes/logoutm.png'
import ListarPublicaciones from "../componentes/ListarPublicaciones";

const Publicaciones = () => {
    return (
        <>
            <HelmetProvider>
                <div>
                    <Helmet>
                        <link rel="shortcut icon" href={favicon} type="image/x-icon"/>
                        <title>Publicaciones - Sistema de Administración Museo UTM</title>
                    </Helmet>
                </div>
            </HelmetProvider>

            <ListarPublicaciones />
        </>
    );
}

export default Publicaciones;